import axios from 'axios';

const api = axios.create({
	baseURL:
		process.env.REACT_APP_ENV === 'dev'
			? 'http://localhost:5000'
			: process.env.REACT_APP_BASE_URL || 'https://api.groupmonkey.io',
});

export default api;
